'use es6';

export const PIPELINE_SNAPSHOT_CONFIG = {
  config: {
    filters: {
      dateRange: {
        property: 'raas_snapshot_dates',
        value: {
          rangeType: 'THIS_MONTH',
          entireCurrentUnit: false
        },
        useFiscalYear: false
      },
      custom: [{
        operator: 'NEQ',
        values: [],
        property: 'dealstage>latest_value.probability',
        value: '1'
      }, {
        operator: 'NEQ',
        values: [],
        property: 'dealstage>latest_value.probability',
        value: '0'
      }, {
        operator: 'HAS_PROPERTY',
        values: [],
        property: 'createdate'
      }]
    },
    customized: false,
    dataType: 'DEALS',
    dimensions: ['raas_snapshot_dates', 'dealstage>latest_value'],
    metrics: [{
      property: 'amount_in_home_currency>latest_value',
      metricTypes: ['SUM']
    }],
    sort: [{
      property: 'dealstage>latest_value.displayOrder',
      order: 'ASC',
      metricType: 'MAX'
    }],
    frequency: 'MONTH',
    configType: 'TIME_SERIES'
  },
  displayParams: {
    stacked: true,
    dataColumns: ['closedate>latest_value', 'createdate', 'hubspot_owner_id', 'hubspot_team_id']
  },
  chartType: 'COLUMN',
  editors: [{
    type: 'METRIC',
    metrics: ['SUM|count', 'SUM|amount_in_home_currency>latest_value']
  }]
};
export const DEAL_PUSH_RATE_CONFIG = {
  config: {
    filters: {
      custom: [{
        value: 2592000000,
        operator: 'GT',
        property: 'closedate>historical_net_change'
      }],
      dateRange: {
        value: {
          rangeType: 'THIS_YEAR',
          entireCurrentUnit: false
        },
        property: 'closedate',
        useFiscalYear: false
      }
    },
    customized: false,
    dataType: 'DEALS',
    dimensions: ['dealstage', 'closedate>has_changes'],
    metrics: [{
      property: 'count',
      metricTypes: ['SUM'],
      percentiles: []
    }],
    sort: [{
      order: 'DESC',
      property: 'count',
      metricType: 'SUM'
    }],
    limit: 15,
    configType: 'AGGREGATION'
  },
  editors: [{
    type: 'QUICK_FILTER',
    operator: 'IN',
    property: 'hubspot_owner_id'
  }, {
    type: 'QUICK_FILTER',
    operator: 'IN',
    property: 'hubspot_team_id'
  }, {
    type: 'QUICK_FILTER',
    operator: 'IN',
    property: 'pipeline'
  }, {
    type: 'QUICK_FILTER',
    operator: 'GT',
    property: 'closedate>historical_net_change'
  }],
  vizType: 'HORIZONTAL_BAR',
  chartType: 'BAR',
  displayParams: {
    colors: {
      theme: 'multi'
    },
    stacked: true,
    dataColumns: ['dealname', 'dealstage', 'pipeline', 'amount_in_home_currency', 'hubspot_owner_id', 'closedate>earliest_value', 'closedate>latest_value', 'closedate>has_changes', 'closedate>count_of_changes', 'closedate>historical_net_change'],
    seriesOrder: {
      type: 'ranked'
    },
    customWidget: {
      type: 'DATA_LAYER'
    }
  }
};
export const DEAL_PIPELINE_WATERFALL_CONFIG = {
  name: 'Deals Pipeline Report',
  config: {
    sort: [],
    filters: {
      dateRange: {
        value: {
          date: null,
          endDate: null,
          rangeType: 'THIS_MONTH',
          startDate: null,
          rollingDays: null,
          rollingDates: null,
          entireCurrentUnit: true
        },
        property: 'raas_snapshot_dates'
      }
    },
    metrics: [{
      property: 'hs_net_pipeline_impact>latest_value',
      metricTypes: ['SUM'],
      percentiles: []
    }],
    dataType: 'DEALS',
    configType: 'AGGREGATION',
    dimensions: ['raas_historical_pipeline_waterfall_changes']
  },
  editors: [],
  chartType: 'WATERFALL',
  resolveType: 'CONFIG',
  displayParams: {
    customWidget: {
      type: 'DATA_LAYER'
    },
    dataColumns: ['amount_in_home_currency', 'dealstage']
  }
};
export const DEAL_CHANGE_HISTORY_CW_CONFIG = {
  config: {
    customized: false,
    processors: [],
    metrics: [{
      property: 'count',
      metricTypes: ['SUM'],
      percentiles: []
    }],
    dataType: 'DEALS',
    compare: null,
    unifiedEvent: null,
    externalDataTypeSource: null,
    unifiedEventTypeName: null,
    dimensions: ['deal_change_type'],
    generated: false,
    eventFunnel: null,
    objectTypeId: null,
    template: null,
    limit: null,
    filters: {
      dateRange: {
        property: 'closedate',
        value: {
          rangeType: 'THIS_MONTH',
          startDate: null,
          endDate: null,
          rollingDates: null,
          rollingDays: null,
          date: null,
          entireCurrentUnit: true
        },
        useFiscalYear: false
      },
      owners: [],
      teams: [],
      custom: []
    },
    configType: 'AGGREGATION',
    sort: [{
      property: 'count',
      order: 'DESC',
      metricType: 'SUM'
    }]
  },
  chartType: 'BAR',
  displayParams: {
    stacked: false,
    seriesOrder: {
      type: 'ranked'
    },
    customWidget: {
      type: 'CHANGE_HISTORY_DEAL_LIST'
    },
    subAppKey: 'changeHistoryDealList',
    salesAnalytics: {
      context: {
        secondaryDateRange: {
          rangeType: 'THIS_MONTH',
          startDate: null,
          endDate: null,
          rollingDates: null,
          rollingDays: null,
          date: null,
          entireCurrentUnit: true
        }
      }
    }
  },
  editors: [{
    type: 'QUICK_FILTER',
    operator: 'IN',
    property: 'hubspot_owner_id'
  }, {
    type: 'QUICK_FILTER',
    operator: 'IN',
    property: 'hubspot_team_id'
  }, {
    type: 'QUICK_FILTER',
    operator: 'EQ',
    property: 'pipeline'
  }, {
    type: 'QUICK_FILTER',
    operator: 'IN',
    property: 'deal_change_type'
  }]
};